/* import __COLOCATED_TEMPLATE__ from './migrate-from-zendesk.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();